import { globalObject } from '../utils/getGlobal'
import { DispatchErrorCollectEvent } from '@/utils/ErrorCollect/utils/CustomErrorEvent'

let ErrorType = 'REQUEST'

function getErrorDetail(event, xhr) {
    return {
        url: xhr.request_url || xhr._url || xhr.url || event.target.responseURL,
        method: xhr._method || xhr.method,
        readyState: xhr.readyState,
        status: xhr.status,
    }
}

export const debugXHR = function(params = {
    slowTime: 5000,
}) {
    // create XMLHttpRequest proxy object
    const oldXMLHttpRequest = globalObject.XMLHttpRequest
    // define constructor for my proxy object
    globalObject.XMLHttpRequest = function() {
        const actual = new oldXMLHttpRequest()
        // var self = this
        // this.onreadystatechange = null
        // this is the actual handler on the real XMLHttpRequest object
        let timer = null
        actual.request_url = 'fc'
        actual.addEventListener('error', function(err) {
            ErrorType = 'REQUEST_ERROR'
            const error_detail = getErrorDetail(err, actual)
            console.log('actual', actual)
            if (error_detail.url &&
                !/ErrorLog\/errorLog/.test(error_detail.url)) {
                DispatchErrorCollectEvent({
                    error_type: ErrorType,
                    error_msg: `接口出错`,
                    error_lv: 0,
                    error_detail,
                })
            }
        }, true)
        actual.addEventListener('loadstart', (e) => {
            if (Number(params.slowTime) > 0) {
                timer = setTimeout(() => {
                    const error_detail = getErrorDetail(e, actual)
                    DispatchErrorCollectEvent({
                        error_type: 'REQUEST_SLOW_NETWORK',
                        error_msg: `请求超过${params.slowTime}ms`,
                        error_lv: 0,
                        error_detail,
                    })
                }, params.slowTime)
            }
        })
        actual.addEventListener('loadend', () => {
            if (timer) {
                clearTimeout(timer)
            }
        })
        actual.addEventListener('timeout', (e) => {
            DispatchErrorCollectEvent({
                error_type: 'REQUEST_TIMEOUT',
                error_lv: 0,
                error_msg: '接口超时',
                detail: getErrorDetail(e, actual),
            })
        })

        // const originState = [
        //     'status',
        //     'statusText',
        //     'responseType',
        //     'response',
        //     'readyState',
        //     'responseXML',
        //     'upload']
        // originState.forEach(
        //     function(item) {
        //         Object.defineProperty(self, item, {
        //             get: function() {
        //                 return actual[item]
        //             },
        //             set: function(val) {
        //                 actual[item] = val
        //             },
        //         })
        //     });
        // // add all proxy getters/setters
        // [
        //     'ontimeout, timeout',
        //     'withCredentials',
        //     'onload',
        //     'onerror',
        //     'onprogress'].forEach(function(item) {
        //     Object.defineProperty(self, item, {
        //         get: function() {
        //             return actual[item]
        //         },
        //         set: function(val) {
        //             actual[item] = val
        //         },
        //     })
        // });
        // // add all pure proxy pass-through methods
        // [
        //     'addEventListener',
        //     'send',
        //     'open',
        //     'abort',
        //     'getAllResponseHeaders',
        //     'getResponseHeader',
        //     'overrideMimeType',
        //     'setRequestHeader',
        //     'removeEventListener',
        // ].forEach(function(item) {
        //     Object.defineProperty(self, item, {
        //         value: function() {
        //             return actual[item].apply(actual, arguments)
        //         },
        //     })
        // })
        return actual
    }
}
